module.exports = __webpack_public_path__ + "img/calendar.597bdafe.svg";